import createAxios from 'config/axios'

const URL = '/registrar/v3/customers/personalinfo'
const URL_UPDATE = '/registrar/v4/customers/personalinfo'
const URL_UPDATE_TOKEN = '/registrar/v5/customers/personalinfo'
const CHANGE_PASSWORD_URL = '/alcatraz/password'

export const getPersonalInfo = () => createAxios.get(URL)

export const patchPersonalInfo = payload => createAxios.put(URL_UPDATE, payload)

export const patchPersonalInfoToken = payload => createAxios.put(URL_UPDATE_TOKEN, payload)

export const updatePassword = ({ eletronicSignature, ...payload }) =>
  createAxios.patch(CHANGE_PASSWORD_URL, {
    ...payload,
    electronicSignature: eletronicSignature
  })

const config = { headers: { 'Content-Type': 'multipart/form-data' } }

export const updatePhoto = payload =>
  createAxios.put('/registrar/v1/customers/photo', payload, config)

export const getPhoto = () => createAxios.get('/registrar/v1/customers/photo')
